
    import * as React from 'react';

    const Search24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M20.3 21l-4.817-4.806a7.526 7.526 0 01-10.279-.342 7.53 7.53 0 010-10.647A7.529 7.529 0 0116.19 15.488L21 20.302l-.7.698zM18 17l-2-2 2 2zM15.096 5.904a6.5 6.5 0 10-9.193 9.193 6.5 6.5 0 009.193-9.193z" /></svg>
        </div>
      );
    };

    Search24.displayName = 'Search24';

    export default Search24;
  